import { render, staticRenderFns } from "./BuyingList.vue?vue&type=template&id=139388d6&scoped=true"
import script from "./BuyingList.vue?vue&type=script&lang=js"
export * from "./BuyingList.vue?vue&type=script&lang=js"
import style0 from "./BuyingList.vue?vue&type=style&index=0&id=139388d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139388d6",
  null
  
)

export default component.exports